import { cn } from '@repo/lib/cn';

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { questionCorrect } from '@/lib/quiz';

import type { GapSelectProps } from '.';

export function GapSelect(gapSelectProps: GapSelectProps) {
  const { gap, value, onValueChange, correct, showMarked, disabled, ...props } = gapSelectProps;
  const { getStateClassNames } = questionCorrect(correct);

  return (
    <Select value={value} onValueChange={(value) => onValueChange(value, gap.id)} {...props}>
      <SelectTrigger className={cn('h-7 w-fit gap-1 px-2 py-0 text-sm disabled:opacity-100', getStateClassNames())} disabled={showMarked || disabled}>
        <SelectValue placeholder={'Wybierz odpowiedź'} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {gap.options.map((option) => (
            <SelectItem key={option.id} value={option.id}>
              {option.content}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
